import { render, staticRenderFns } from "./dr-button-popup-menu.vue?vue&type=template&id=088e54dd"
import script from "./dr-button-popup-menu.vue?vue&type=script&lang=js"
export * from "./dr-button-popup-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports